/*
 * Built on Nuxt UI's useToast (auto-imported; needs the <UApp> wrapper in App.vue).
 * Called from inside a component's setup or a handler it owns — useToast() reads a
 * provider off the component tree.
 */
export const PrintSuccess = (message: string) => {
    const toast = useToast()
    toast.add({ title: message, color: 'success', duration: 3000 })
}

export const PrintError = (message: string) => {
    const toast = useToast()
    toast.add({ title: message, color: 'error', duration: 6000 })
}

/*
 * Something worth reading that is neither a success nor a failure — the tasks a schedule
 * change pushed later, above all. It stays longer, because it carries a list.
 */
export const PrintNotice = (title: string, description: string) => {
    const toast = useToast()
    toast.add({ title, description, color: 'info', icon: 'i-lucide-calendar-sync', duration: 9000 })
}
